import { render, staticRenderFns } from "./AddHeadingPopup.vue?vue&type=template&id=0f3722fc"
import script from "./AddHeadingPopup.vue?vue&type=script&lang=js"
export * from "./AddHeadingPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports